import { render } from "./GestionRegularizacionesList.vue?vue&type=template&id=066e5a94"
import script from "./GestionRegularizacionesList.vue?vue&type=script&lang=js"
export * from "./GestionRegularizacionesList.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.5.28_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__